import { createRouter, createWebHistory } from 'vue-router';
import VisualizationView from '../views/VisualizationView.vue';

const routes = [
  {
    path: '/',
    name: 'Visualization',
    component: VisualizationView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
